// sync with projects/root/src/client/init-cookie-modal-hack.ts
export const TRUSTED_HOSTS = ['rb.m2', 'm2.region.vtb.ru', 'open.m2.ru'];

export const INTERNAL_DOMAINS = ['m2.ru', 'test-m2.ru', 'dev-m2.ru', 'stage-m2.ru', 'perf-m2.ru', ...TRUSTED_HOSTS];
